import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";
import type { PresenceEntry } from "../../types/data-table";

interface PresenceAvatarsProps {
  viewers: PresenceEntry[];
  currentInstanceId?: string;
  max?: number;
}

function getInitials(name: string): string {
  return name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

const COLORS = [
  "bg-blue-500",
  "bg-green-500",
  "bg-purple-500",
  "bg-orange-500",
  "bg-pink-500",
  "bg-teal-500",
];

function colorForUser(userId: number): string {
  return COLORS[userId % COLORS.length]!;
}

export function PresenceAvatars({
  viewers,
  currentInstanceId,
  max = 3,
}: PresenceAvatarsProps) {
  const filtered = currentInstanceId
    ? viewers.filter((v) => v.instanceId !== currentInstanceId)
    : viewers;

  if (filtered.length === 0) return null;

  const visible = filtered.slice(0, max);
  const overflow = filtered.length - max;

  return (
    <div className="flex -space-x-2">
      {visible.map((viewer) => (
        <Tooltip key={viewer.instanceId}>
          <TooltipTrigger asChild>
            <div
              className={`flex h-6 w-6 items-center justify-center rounded-full text-[10px] font-medium text-white ring-2 ring-background ${colorForUser(viewer.userId)}`}
            >
              {getInitials(viewer.userName)}
            </div>
          </TooltipTrigger>
          <TooltipContent>{viewer.userName} is viewing</TooltipContent>
        </Tooltip>
      ))}
      {overflow > 0 && (
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-muted text-[10px] font-medium ring-2 ring-background">
          +{overflow}
        </div>
      )}
    </div>
  );
}
